module.exports = __webpack_public_path__ + "static/vote-header-cecf34adb41270a3b46e5f178deabe50.png";